/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { triggersCreate } from "../funcs/triggersCreate.js";
import { triggersDelete } from "../funcs/triggersDelete.js";
import { triggersGet } from "../funcs/triggersGet.js";
import { triggersList } from "../funcs/triggersList.js";
import { triggersListDefinitions } from "../funcs/triggersListDefinitions.js";
import { triggersListEvents } from "../funcs/triggersListEvents.js";
import { triggersPause } from "../funcs/triggersPause.js";
import { triggersResume } from "../funcs/triggersResume.js";
import { triggersUpdate } from "../funcs/triggersUpdate.js";
import { ClientSDK, RequestOptions } from "../lib/sdks.js";
import { ListTriggerDefinitionsResult } from "../models/components/listtriggerdefinitionsresult.js";
import { ListTriggerEventsResult } from "../models/components/listtriggereventsresult.js";
import { ListTriggerInstancesResult } from "../models/components/listtriggerinstancesresult.js";
import { TriggerInstance } from "../models/components/triggerinstance.js";
import {
  CreateTriggerInstanceRequest,
  CreateTriggerInstanceSecurity,
} from "../models/operations/createtriggerinstance.js";
import {
  DeleteTriggerInstanceRequest,
  DeleteTriggerInstanceSecurity,
} from "../models/operations/deletetriggerinstance.js";
import {
  GetTriggerInstanceRequest,
  GetTriggerInstanceSecurity,
} from "../models/operations/gettriggerinstance.js";
import {
  ListTriggerDefinitionsRequest,
  ListTriggerDefinitionsSecurity,
} from "../models/operations/listtriggerdefinitions.js";
import {
  ListTriggerEventsRequest,
  ListTriggerEventsSecurity,
} from "../models/operations/listtriggerevents.js";
import {
  ListTriggerInstancesRequest,
  ListTriggerInstancesSecurity,
} from "../models/operations/listtriggerinstances.js";
import {
  PauseTriggerInstanceRequest,
  PauseTriggerInstanceSecurity,
} from "../models/operations/pausetriggerinstance.js";
import {
  ResumeTriggerInstanceRequest,
  ResumeTriggerInstanceSecurity,
} from "../models/operations/resumetriggerinstance.js";
import {
  UpdateTriggerInstanceRequest,
  UpdateTriggerInstanceSecurity,
} from "../models/operations/updatetriggerinstance.js";
import { unwrapAsync } from "../types/fp.js";

export class Triggers extends ClientSDK {
  /**
   * createTriggerInstance triggers
   *
   * @remarks
   * Create a trigger instance.
   */
  async create(
    request: CreateTriggerInstanceRequest,
    security?: CreateTriggerInstanceSecurity | undefined,
    options?: RequestOptions,
  ): Promise<TriggerInstance> {
    return unwrapAsync(triggersCreate(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * deleteTriggerInstance triggers
   *
   * @remarks
   * Delete a trigger instance.
   */
  async delete(
    request: DeleteTriggerInstanceRequest,
    security?: DeleteTriggerInstanceSecurity | undefined,
    options?: RequestOptions,
  ): Promise<void> {
    return unwrapAsync(triggersDelete(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * getTriggerInstance triggers
   *
   * @remarks
   * Get a trigger instance by ID.
   */
  async get(
    request: GetTriggerInstanceRequest,
    security?: GetTriggerInstanceSecurity | undefined,
    options?: RequestOptions,
  ): Promise<TriggerInstance> {
    return unwrapAsync(triggersGet(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * listTriggerInstances triggers
   *
   * @remarks
   * List trigger instances for the current project.
   */
  async list(
    request?: ListTriggerInstancesRequest | undefined,
    security?: ListTriggerInstancesSecurity | undefined,
    options?: RequestOptions,
  ): Promise<ListTriggerInstancesResult> {
    return unwrapAsync(triggersList(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * listTriggerDefinitions triggers
   *
   * @remarks
   * List static trigger definitions available to a project.
   */
  async listDefinitions(
    request?: ListTriggerDefinitionsRequest | undefined,
    security?: ListTriggerDefinitionsSecurity | undefined,
    options?: RequestOptions,
  ): Promise<ListTriggerDefinitionsResult> {
    return unwrapAsync(triggersListDefinitions(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * listTriggerEvents triggers
   *
   * @remarks
   * List recent dispatch events for a trigger instance.
   */
  async listEvents(
    request: ListTriggerEventsRequest,
    security?: ListTriggerEventsSecurity | undefined,
    options?: RequestOptions,
  ): Promise<ListTriggerEventsResult> {
    return unwrapAsync(triggersListEvents(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * pauseTriggerInstance triggers
   *
   * @remarks
   * Pause a trigger instance.
   */
  async pause(
    request: PauseTriggerInstanceRequest,
    security?: PauseTriggerInstanceSecurity | undefined,
    options?: RequestOptions,
  ): Promise<TriggerInstance> {
    return unwrapAsync(triggersPause(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * resumeTriggerInstance triggers
   *
   * @remarks
   * Resume a trigger instance.
   */
  async resume(
    request: ResumeTriggerInstanceRequest,
    security?: ResumeTriggerInstanceSecurity | undefined,
    options?: RequestOptions,
  ): Promise<TriggerInstance> {
    return unwrapAsync(triggersResume(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * updateTriggerInstance triggers
   *
   * @remarks
   * Update a trigger instance.
   */
  async update(
    request: UpdateTriggerInstanceRequest,
    security?: UpdateTriggerInstanceSecurity | undefined,
    options?: RequestOptions,
  ): Promise<TriggerInstance> {
    return unwrapAsync(triggersUpdate(
      this,
      request,
      security,
      options,
    ));
  }
}
